import React from 'react'
import styled from 'styled-components'

type BadgeProps = {
  label: string
  className?: string
}

const Badge: React.FunctionComponent<BadgeProps> = ({ label, className }) => {
  return <StyledBadge className={className}>{label}</StyledBadge>
}

export default Badge

const StyledBadge = styled.span`
  text-align: center;
  padding: 0 6px;
  color: #757575;
  font-size: 1rem;
  font-weight: bold;
`
